import { useEffect } from 'react';

const ZOOM_KEYS = new Set(['+', '=', '-', '_', '0']);
const LOCKED_VIEWPORT = 'maximum-scale=1.0, user-scalable=no';

/**
 * While mounted, stops the browser's page-level zoom (Ctrl/Cmd + wheel, Ctrl/Cmd +/-/0, and touch pinch) so the PDF
 * viewer's own zoom controls are the only way to zoom. Everything is restored on unmount.
 */
export const useBlockBrowserZoom = () => {
  useEffect(() => {
    const onWheel = (event: WheelEvent) => {
      if (event.ctrlKey) event.preventDefault();
    };
    const onKeyDown = (event: KeyboardEvent) => {
      if ((event.ctrlKey || event.metaKey) && ZOOM_KEYS.has(event.key)) event.preventDefault();
    };
    // iOS Safari ignores user-scalable=no, so cancel its pinch gesture directly.
    const onGestureStart = (event: Event) => event.preventDefault();

    document.addEventListener('wheel', onWheel, { passive: false });
    document.addEventListener('keydown', onKeyDown);
    document.addEventListener('gesturestart', onGestureStart);

    const viewport = document.querySelector<HTMLMetaElement>('meta[name="viewport"]');
    const originalViewport = viewport?.content;
    if (viewport && originalViewport !== undefined) viewport.content = `${originalViewport}, ${LOCKED_VIEWPORT}`;

    return () => {
      document.removeEventListener('wheel', onWheel);
      document.removeEventListener('keydown', onKeyDown);
      document.removeEventListener('gesturestart', onGestureStart);
      if (viewport && originalViewport !== undefined) viewport.content = originalViewport;
    };
  }, []);
};
